module.exports = __webpack_public_path__ + "images/emoji/hourglass.48aa1aea9041085d1f53.png";